"use client";

import { Leaf } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInTouch() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const cards = [{
    heading: "Field Services",
    description: "Expert onsite CNC integration, retrofitting, and specialized maintenance for Siemens, Heidenhain, and Fanuc systems.",
    linkText: "View Field Services",
    to: "/FieldServicesPage"
  }, {
    heading: "Siemens Parts",
    description: "Access our extensive inventory of genuine Siemens spare parts to keep your industrial operations running at peak efficiency.",
    linkText: "Browse Spare Parts",
    to: "/PartsCataloguePage"
  }];
  return <section data-section-id="165" id="get-in-touch" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-40 px-6">
      {}
      <div className="pointer-events-none absolute -bottom-20 -left-20 w-[600px] h-[600px] opacity-[0.04]" aria-hidden="true">
        <svg viewBox="0 0 600 600" fill="none" className="w-full h-full">
          <path d="M100 500 Q 150 400 200 380 Q 280 350 300 280 Q 320 200 380 180 Q 460 150 480 80" stroke="var(--chart-3)" strokeWidth="1.5" fill="none" />
          <path d="M120 520 Q 180 460 240 440 Q 320 410 340 340" stroke="var(--chart-3)" strokeWidth="1.5" fill="none" />
          <ellipse cx="200" cy="380" rx="30" ry="12" stroke="var(--chart-3)" strokeWidth="1" fill="none" transform="rotate(-30 200 380)" />
          <ellipse cx="300" cy="280" rx="35" ry="14" stroke="var(--chart-3)" strokeWidth="1" fill="none" transform="rotate(-45 300 280)" />
          <ellipse cx="380" cy="180" rx="30" ry="12" stroke="var(--chart-3)" strokeWidth="1" fill="none" transform="rotate(-60 380 180)" />
          <ellipse cx="240" cy="440" rx="28" ry="11" stroke="var(--chart-3)" strokeWidth="1" fill="none" transform="rotate(-25 240 440)" />
        </svg>
      </div>

      <div className="relative mx-auto max-w-[760px]">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="mb-10" aria-hidden="true">
            
          </div>

          {}
          

          {}
          <h2 className="font-default font-bold text-[40px] md:text-[52px] leading-[1.1] text-foreground mb-10 tracking-tight">
            Precision Engineering. Siemens Expertise.{" "}
            <em className="italic font-bold text-primary">Reliable</em> Solutions.
          </h2>

          {}
          <div className="space-y-6 text-lg text-muted-foreground font-default" style={{
          lineHeight: 1.6
        }}>
            <p>IMCNC Designs is your premier partner for high-quality CNC integration and retrofitting. Based in Gauteng, South Africa, we specialize in delivering technical excellence for industrial automation across multiple business segments and industries.</p>
            <p>
              Schedule an onsite appointment and let us assist you with all your CNC retrofitting, 
              field services, and Siemens spare parts requirements. Our certified technicians ensure 
              your machinery operates with absolute precision and minimal downtime.
            </p>
          </div>
        </div>

        {}
        <div ref={cardsRef} className={`mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 transition-all duration-1000 delay-200 ease-out ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {cards.map((card, i) => <Card data-index={i} key={i} className="group relative bg-card border border-border rounded-md p-8 md:p-10 transition-all duration-300 hover:-translate-y-1 hover:border-primary hover:bg-accent hover:shadow-md">
              <div className="flex flex-col items-start gap-5">
                <div className="flex h-12 w-12 items-center justify-center rounded-md border border-primary/40 bg-background">
                  <Leaf className="h-5 w-5 text-primary" strokeWidth={1.5} />
                </div>

                <h3 className="font-default text-2xl md:text-[25px] font-bold text-foreground">
                  {card.heading}
                </h3>

                <p className="text-base text-muted-foreground font-default" style={{
              lineHeight: 1.6
            }}>
                  {card.description}
                </p>

                <Button asChild variant="link" className="h-auto p-0 text-primary hover:text-primary/80 font-default text-sm tracking-wide group/link">
                  <Link to={card.to}>
                    <span>{card.linkText}</span>
                    <span className="inline-block transition-transform duration-300 group-hover/link:translate-x-1">
                      &rarr;
                    </span>
                  </Link>
                </Button>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}